import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=4e72f5a1&scoped=true&"
import script from "./addModal.vue?vue&type=script&lang=js&"
export * from "./addModal.vue?vue&type=script&lang=js&"
import style0 from "./addModal.vue?vue&type=style&index=0&id=4e72f5a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e72f5a1",
  null
  
)

export default component.exports